import { CategoryUnionType } from '@api';
import { MultiSelectField } from '@hypeit-gmbh/hypeit-ui';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'EDIT_COMPANY_LINK_FORM.CATEGORIES_FIELDS';

type CategoriesPropsType = {
  companyLinkCategories: CategoryUnionType[];
};

export const Categories: React.FC<CategoriesPropsType> = ({
  companyLinkCategories,
}) => {
  const { t } = useTranslation('common');

  const multiSelectData = companyLinkCategories.map((category) => ({
    label: t(`COMPANY_LINKS.CATEGORIES.${category}`),
    value: category,
  }));

  return (
    <MultiSelectField
      fieldName="categories"
      data={multiSelectData}
      label={t(`${TRANS_PATH}.CATEGORIES_LABEL`)}
      placeholder={t(`${TRANS_PATH}.CATEGORIES_PLACEHOLDER`)}
      searchable
    />
  );
};
